<template>
  <PopUp
    v-if="popupActive"
    unbottom
    :pop-up-active="popupActive"
    :title="isLoading?'':lawContent.title"
    @click="$_PopupClose()"
  >
    <DotLoading v-if="isLoading" />
    <div v-else>
      <div
        v-if="lawContent.rich_content"
        class="ll-act-popup html-text"
        v-html="lawContent.rich_content"
      />
      <div
        v-else
        class="ll-act-popup html-text"
        v-html="lawContent.content"
      />
      <div
        v-if=" (lawContent.riskSignal && lawContent.riskSignal.length>0) || lawContent.commentContent"
        class="ll-act-popup__comment"
      >
        <div class="ll-act-popup__comment-title">
          {{ lawContent.commentTitle }}
        </div>
        <div class="ll-act-popup__comment-risk-signal">
          <div
            v-for="(riskSignalItem,riskSignalIntex) in lawContent.riskSignal"
            :key="riskSignalIntex"
            class="ll-act-popup__comment-risk-signal-item"
          >
            <i :class="riskSignalItem.icon" />
            <p>{{ riskSignalItem.text ? riskSignalItem.text : riskSignalItem.name }}</p>
          </div>
        </div>
        <div class="ll-act-popup__comment-content">
          {{ lawContent.commentContent }}
        </div>
      </div>
    </div>
  </PopUp>
  <PopUp
    v-else
    :pop-up-active="popupActive"
    @click="$_PopupClose()"
  />
</template>
<script>
export default {
  name: "LlActPopup",

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    lawContent: {
      type: Object,
      default() {
        return {};
      },
    },
    popupActive: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    $_PopupClose() {
      this.$emit("popup-close");
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/component/ll-act-popup";
</style>